import moment from 'moment';
import * as Yup from 'yup';

export const optionsStyle = {
	menuPortal: (base) => ({ ...base, zIndex: 9999 }),
	menu: (base) => ({
		...base,
		maxHeight: 200,
		overflowY: 'auto',
		overflowX: 'hidden',
		marginTop: 0,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
	}),
	menuList: (base) => ({
		...base,
		maxHeight: 200,
		overflowY: 'auto',
		overflowX: 'hidden',
		overscrollBehavior: 'contain',
		wordBreak: 'break-word',
	}),
};

export const visitInitialValues = {
	sysExamination: {
		generalId: '',
		cvsId: '',
		rsId: '',
		cnsId: '',
		paId: '',
		entId: '',
		generalName: '',
		cvsName: '',
		rsName: '',
		cnsName: '',
		paName: '',
		entName: '',
	},
	vitals: {
		height: '',
		weight: '',
		pulse: '',
		bp: '',
		temperature: '',
		spo2: '',
	},
	complaints: [
		{
			id: 1,
			complaintId: '',
			frequencyId: '',
			severityId: '',
			durationId: '',
			complaintName: '',
			frequencyName: '',
			severityName: '',
			durationName: '',
			date: '',
			existingVisitComplaintId: null,
		},
	],
	diagnosis: [
		{
			id: 1,
			diagnosisId: '',
			durationId: '',
			diagnosisName: '',
			durationName: '',
			date: '',
			existingVisitDiagnosisId: null
		},
	],
	rx: [
		{
			id: 1,
			medicineId: '',
			doseId: '',
			timingId: '',
			frequencyId: '',
			durationId: '',
			medicineName: '',
			doseName: '',
			timingName: '',
			frequencyName: '',
			durationName: '',
			note: '',
			existingVisitMedicineId: null,
		},
	],
	history: '',
	advice: [{
		id: 1,
		adviceId: '',
		adviceName: '',
	}],
	testRequired: [{
		id: 1,
		testRequiredId: '',
		testRequiredName: '',
	}],
	testDeadline: { testDurationId: null, testDeadlineId: '', testDeadlineName: '', testDeadlineDurationName: '' },
	dietExercise: [{
		id: 1,
		dietExerciseId: '',
		dietExerciseName: '',
	}],
	nextVisit: {
		nextVisit: '',
		nextVisitDate: '',
		period: 'DAY',
	},
	referTo: { drName: '', mobile: '', email: '' },
};

export const setVisitInitialValues = (selectedVisit) => {

	const newValues = {
		sysExamination: {
			generalId: selectedVisit.general_examam_id,
			cvsId: selectedVisit.csv_exam_id,
			rsId: selectedVisit.rs_exam_id,
			cnsId: selectedVisit.cns_exam_id,
			paId: selectedVisit.pa_exam_id,
			entId: selectedVisit.ent_exam_id,
		},
		vitals: {
			height: Number(selectedVisit.height || 0),
			weight: Number(selectedVisit.weight || 0),
			pulse: Number(selectedVisit.pulse || 0),
			bp: selectedVisit.bp || '',
			temperature: Number(selectedVisit.temperature || 0),
			spo2: Number(selectedVisit.spo2 || 0),
		},
		complaints: selectedVisit.complaints && selectedVisit.complaints.length > 0 ? selectedVisit.complaints.map((complaint, index) => ({
			id: index + 1,
			complaintId: complaint.complaint_id,
			frequencyId: complaint.frequency_id,
			severityId: complaint.severity_id,
			durationId: complaint.duration_id,
			date: complaint.date ? moment(complaint.date).format('YYYY-MM-DD') : '',
			existingVisitComplaintId: complaint.id,
		})) : visitInitialValues.complaints,
		diagnosis: selectedVisit.diagnosis && selectedVisit.diagnosis.length > 0 ? selectedVisit.diagnosis.map((diagnosis, index) => ({
			id: index + 1,
			diagnosisId: diagnosis.diagnosis_id,
			durationId: diagnosis.duration_id,
			date: diagnosis.date ? moment(diagnosis.date).format('YYYY-MM-DD') : '',
			existingVisitDiagnosisId: diagnosis.id,
		})) : visitInitialValues.diagnosis,
		rx: selectedVisit.prescriptions && selectedVisit.prescriptions.length > 0 ? selectedVisit.prescriptions.map((rx, index) => ({
			id: index + 1,
			medicineId: rx.medicine_id,
			doseId: rx.dose_id,
			timingId: rx.timing_id,
			frequencyId: rx.frequency_id,
			durationId: rx.duration_id,
			note: rx.notes,
			existingVisitMedicineId: rx.id,
		})) : visitInitialValues.rx,
		history: selectedVisit.history,
		advice: selectedVisit.advices.map((advice, index) => ({
			id: index + 1,
			adviceId: advice.advice_id,
		})),
		testRequired: selectedVisit.testRequireds.map((testRequired, index) => ({
			id: index + 1,
			testRequiredId: testRequired.test_id,
		})),
		testDeadline: {
			testDurationId: selectedVisit?.test_duration_id || null,
			testDeadlineId: selectedVisit?.test_deadline_id || null,
		},
		dietExercise: selectedVisit.dietExercises.map((dietExercise, index) => ({
			id: index + 1,
			dietExerciseId: dietExercise.diet_exercise_id,
		})),
		nextVisit: {
			nextVisit: selectedVisit.next_visit,
			nextVisitDate: selectedVisit.next_visit_date ? moment(selectedVisit.next_visit_date).format('YYYY-MM-DD') : '',
			period: selectedVisit.next_visit_type ? selectedVisit.next_visit_type.toUpperCase() : 'DAY',
		},
		referTo: {
			drName: selectedVisit.refer_doctor,
			mobile: selectedVisit.refer_mobile,
			email: selectedVisit.refer_email,
		},
	};
	return newValues;
};

export const visitValidationSchema = Yup.object({
	vitals: Yup.object({
		height: Yup.string()
			.matches(/^\d+$/, 'Height must be a number'),
		weight: Yup.string()
			.matches(/^\d+$/, 'Weight must be a number'),
		pulse: Yup.string()
			.matches(/^\d+$/, 'Pulse rate must be a number'),
		bp: Yup.string()
			// eslint-disable-next-line no-useless-escape
			.matches(/^(\d{2,3}|\d{2,3}\s*[/\-]\s*\d{2,3})$/, 'Blood pressure must be a valid number (e.g. 120 or 120/80)'),
		temperature: Yup.string()
			.matches(/^\d+(\.\d+)?$/, 'Temperature must be a valid number'),
		spo2: Yup.string()
			.matches(/^\d+$/, 'SpO2 must be a number'),
	}),
	referTo: Yup.object({
		email: Yup.string()
			.optional()
			.nullable()
			.test('is-valid-email', 'Invalid email format', function(value) {
				if (!value) return true;
				return Yup.string().email().isValidSync(value);
			}),
		mobile: Yup.string()
			.optional()
			.nullable()
			.test('is-valid-phone', 'Phone number must be 10 digits', function(value) {
				if (!value) return true;
				return /^\d{10}$/.test(value);
			}),
	}),
});

export const getTouchedVitals = (errors) => {
	const vitalFields = ['height', 'weight', 'pulse', 'bp', 'temperature', 'spo2'];
	const touched = {};
	let hasError = false;

	const vitalErrors = errors?.vitals || {};
	vitalFields.forEach((field) => {
		if (vitalErrors[field]) {
			touched[field] = true;
			hasError = true;
		}
	});

	return { touched: { vitals: touched }, hasError };
};

export const getTouchedArrayFields = (errors, fieldKey) => {
	const errorField = errors?.[fieldKey];

	if (typeof errorField === 'string') {
		return {
			touched: { [fieldKey]: true },
			hasError: true,
		};
	}

	if (Array.isArray(errorField)) {
		const touchedArray = errorField.map((err) => {
			const rowTouched = {};
			Object.keys(err || {}).forEach((key) => {
				rowTouched[key] = true;
			});
			return rowTouched;
		});

		return {
			touched: { [fieldKey]: touchedArray },
			hasError: touchedArray.length > 0,
		};
	}
	return {
		touched: {},
		hasError: false,
	};
};

export const getTouchedObjectFields = (errors, fieldKey) => {
	const errorField = errors?.[fieldKey];
	const touched = {};
	let hasError = false;

	if (errorField && typeof errorField === 'object') {
		Object.keys(errorField).forEach(key => {
			if (errorField[key]) {
				touched[key] = true;
				hasError = true;
			}
		});
	}

	return {
		touched: { [fieldKey]: touched },
		hasError,
	};
};